import React from 'react';
import './toast.scss';
import Toast from 'react-bootstrap/Toast';
import { CustomToastBody } from './toast.styles';

interface WrapperProps {
  message?: string;
  clickableText?: string;
  onClick?: () => void;
  show: boolean;
  style?: React.CSSProperties;
}

export const ToastWrapper: React.FC<WrapperProps> = ( {message, clickableText, onClick, show, style} ) => {
  return (
    <>
      <Toast show={show} autohide={false} onClick={() => onClick()} style={style}>
        <CustomToastBody className="text-center">
          <strong className="me-auto">
            {message} <u style={{cursor:'pointer'}} onClick={() => onClick()}>{clickableText}</u>
          </strong>
        </CustomToastBody>
      </Toast>
    </>
  );
};
